// @ts-expect-error - Missing declaration file for conversations-internal-schema module

import { List } from 'immutable';
function isCollection(value) {
  if (!value) {
    return false;
  }
  if (List.isList(value)) {
    return true;
  }
  return typeof value.forEach === 'function';
}
export function isMessagesCollection(value) {
  return isCollection(value);
}